import { Action } from "./action";
import { ActionDescriptor } from "./action_descriptor";
import { ActionSet } from "./action_set";
import { InlineActionObserver } from "./inline_action_observer";
import { Scope } from "./scope";

var Context =
/** @class */
function () {
  function Context(contextSet, element) {
    this.contextSet = contextSet;
    this.scope = new Scope(this.configuration, this.identifier, element);
    this.actions = new ActionSet(this);
    this.inlineActionObserver = new InlineActionObserver(this, this);

    try {
      this.controller = new contextSet.controllerConstructor(this);
      this.controller.initialize();
    } catch (error) {
      this.reportError(error, "initializing controller \"" + this.identifier + "\"");
    }
  }

  Context.prototype.connect = function () {
    this.actions.start();
    this.inlineActionObserver.start();

    try {
      this.controller.connect();
    } catch (error) {
      this.reportError(error, "connecting controller \"" + this.identifier + "\"");
    }
  };

  Context.prototype.disconnect = function () {
    try {
      this.controller.disconnect();
    } catch (error) {
      this.reportError(error, "disconnecting controller \"" + this.identifier + "\"");
    }

    this.inlineActionObserver.stop();
    this.actions.stop();
  };

  Object.defineProperty(Context.prototype, "application", {
    get: function get() {
      return this.contextSet.application;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Context.prototype, "identifier", {
    get: function get() {
      return this.contextSet.identifier;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Context.prototype, "configuration", {
    get: function get() {
      return this.application.configuration;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Context.prototype, "element", {
    get: function get() {
      return this.scope.element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Context.prototype, "parentElement", {
    get: function get() {
      return this.element.parentElement;
    },
    enumerable: true,
    configurable: true
  });

  Context.prototype.addAction = function (actionOrDescriptorString, eventTarget) {
    var action;

    if (actionOrDescriptorString instanceof Action) {
      action = actionOrDescriptorString;
    } else if (typeof actionOrDescriptorString == "string") {
      var descriptorString = actionOrDescriptorString;

      if (!isEventTarget(eventTarget)) {
        eventTarget = this.element;
      }

      var descriptor = ActionDescriptor.forElementWithInlineDescriptorString(eventTarget, descriptorString);
      action = new Action(this, descriptor, eventTarget);
    }

    if (action) {
      this.actions.add(action);
    }
  };

  Context.prototype.removeAction = function (action) {
    this.actions.delete(action);
  }; // Inline action observer delegate


  Context.prototype.inlineActionConnected = function (action) {
    this.addAction(action);
  };

  Context.prototype.inlineActionDisconnected = function (action) {
    this.removeAction(action);
  }; // Logging


  Context.prototype.reportError = function (error, message) {
    var args = [];

    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }

    var argsFormat = args.map(function (arg) {
      return "%o";
    }).join("\n");
    var format = "Error %s\n\n%o\n\n" + argsFormat + "\n%o\n%o";
    return console.error.apply(console, [format, message, error].concat(args, [this.controller, this.element]));
  };

  return Context;
}();

export { Context };

function isEventTarget(object) {
  if (!object) {
    return false;
  } else if (typeof EventTarget != "undefined") {
    return object instanceof EventTarget;
  } else {
    return typeof object.addEventListener == "function";
  }
}